export class FiltroCusto {
    EmpresaId: number = null;
    FazendaId: number = null;
    EquipamentoId: number = null;
    GrupoEquipamentoId: number = null;
    Filtro: string = null;
    DataInicio: Date = null;
    DataFim: Date = null;
}